<template>
  <ion-page>
    <ion-tabs>
      <van-icon name="icon-shouye"/>
      <ion-router-outlet animated="false"></ion-router-outlet>
      <ion-tab-bar v-model="active" slot="bottom" @ionTabsWillChange="beforeTabChange" class="ion-foot-bar">
        <ion-tab-button href="/tabs/home" tab="home" class="ion-foot-btn">
          <van-icon class-prefix="iconfont icon-shouye" name="extra" size="20px"/>
          <ion-label style="font-size: 12px">首页</ion-label>
        </ion-tab-button>


        <ion-tab-button href="/tabs/newsTabs" tab="newsTabs" class="ion-foot-btn">
          <van-icon class-prefix="iconfont icon-xiaoxi" name="extra" size="20px"/>
          <ion-label style="font-size: 12px">产品分类</ion-label>
        </ion-tab-button>

        <ion-tab-button href="/tabs/video" tab="video" class="ion-foot-btn">
          <van-icon class-prefix="iconfont icon-xuexi" name="extra" size="20px"/>
          <ion-label style="font-size: 12px">学习</ion-label>
        </ion-tab-button>


        <ion-tab-button href="/tabs/mine" tab="mine" class="ion-foot-btn">
          <van-icon class-prefix="iconfont icon-wode" name="extra" size="20px"/>
          <ion-label style="font-size: 12px">我的</ion-label>
        </ion-tab-button>
      </ion-tab-bar>
    </ion-tabs>

    <van-popup v-model:show="policyAgreeShow" class="policyAgreePopup" style="width: 100%;height: 100vh;">
      <div class="policyAgree-div">
        <h4>用户隐私政策说明</h4>
        <div>
          亲,感谢您对云脉知界一直以来的支持,我们根据最新的监管政策更新云脉知界特向你作如下说明：
          <p>
            1.为向您提供交易相关基本功能我们可能会在您使用期间获取您的位置以及相机等权限(头像上传等);
          </p>
          <p>
            2.我们会努力采取各种安全技术保护您的个人信息。未经您同意，我们不会从第三方获取、共享或对外提供您的信息;
          </p>
          <p>
            3. 您有权拒绝或者取消授权,未经你的授权我们不会从第三方获取或者共享您提供的信息.
          </p>
          <p><small>您还可以阅读完整版的</small> <strong @click="jumpPrivacy">隐私政策</strong></p>
        </div>
        <div class="policyAgreeBtns">
          <van-button plain type="primary" @click="doAgreepolicy">同意并继续</van-button>
          <van-button plain type="success" @click="notDoAgreepolicy">不同意并退出</van-button>
        </div>
      </div>
    </van-popup>
  </ion-page>
</template>

<script>
import {IonLabel, IonPage, IonRouterOutlet, IonTabBar, IonTabButton, IonTabs} from '@ionic/vue';
import {Icon} from 'vant';
import axios from '@/assets/js/axios'

export default {
  components: {
    IonLabel,
    IonTabs,
    IonTabBar,
    IonTabButton,
    IonPage,
    IonRouterOutlet,
    [Icon.name]: Icon,
  },
  ionViewDidEnter() {
    // this.initMsgDot()
    this.privacyPolicy();
  },
  data() {
    return {
      active: 0,
      // showDot: false,
      routerShow: false,
      policyAgreeShow: false
    }
  },
  methods: {
    // initMsgDot() {
    //   let that = this
    //   axios.get('/chatMsg/hasNotRead', null).then(function (ret) {
    //     that.showDot = ret
    //   })
    // },
    privacyPolicy() {
      let policyAgree = localStorage.getItem('policyAgree');
      if (!policyAgree || policyAgree !== 'true') {
        this.policyAgreeShow = true
      } else {
        this.policyAgreeShow = false
        this.routerShow = true
        this.initTurnServer()
      }
    },
    doAgreepolicy() {
      localStorage.setItem('policyAgree', 'true');
      this.policyAgreeShow = false
    },
    notDoAgreepolicy() {
      if (navigator['app']) {
        navigator['app'].exitApp(); //node_modules/@capacitor/ios/Capacitor/Capacitor/WebViewDelegationHandler.swift
      }
    },
    jumpPrivacy() {
      this.$router.push({path: '/privacyPolicy'})
      this.policyAgreeShow = false
    },
    beforeTabChange(e) {
      console.log(e)
    },
    initTurnServer() {
      axios.get('/user/getTurnConfig').then(function (ret) {
        if (ret) {
          localStorage.setItem("baseTurnUrl", ret.baseTurnUrl)
          localStorage.setItem("baseTurnUserName", ret.baseTurnUserName)
          localStorage.setItem("baseTurnUPassword", ret.baseTurnUPassword)
        }
      }).catch(function (e) {
        console.log(e)
      })
    }
  }
}
</script>
<style scoped>
.tab-selected {
  color: #0672bb;
}

.ion-foot-bar {
  padding-top: 4px;
}

.ion-foot-btn {
  background: #0672bb;
  color: white;
}

.policyAgreePopup {
  width: 100vw;
  height: 100vh;
  color: rgb(0, 0, 0);
}

.policyAgree-div h4 {
  text-align: center;
  margin-top: 4rem;
  font-size: 1rem;
}

.policyAgree-div {
  padding-left: 15px;
  padding-right: 15px;
  font-size: 0.95rem;
}

.policyAgreeBtns {
  margin-top: 1.5rem;
}

.policyAgreeBtns button {
  width: 100%;
  margin-bottom: 15px;
}

.policyAgreeBtns .van-button--primary {
  background: #222222;
  border: 0px;
  color: white !important;
}

.policyAgreeBtns .van-button--success {
  border: 0px;
  color: #9a9999 !important;
}

ion-tab-bar {
  border-top: 0;
  background: white;
  box-shadow: 6px 34px 36px 35px rgb(0 0 0 / 10%);
}
</style>